module.exports = __webpack_public_path__ + "img/trial2-3.73008f6b.png";